import * as React from 'react';
import style from './TopBarNavigationLinks.scss';
import classnames from 'classnames';
import { ExternalLink } from '../../../PageElements/ExternalLink';

export const TopBarNavigationLinks = ({ links }) => (
  <nav className={style.headerNav} data-hook="top-bar-navigation-links">
    {links.map(({ name, url, active }) => (
      <ExternalLink
        key={name}
        href={url}
        className={classnames({
          [style.headerLink]: true,
          [style.active]: active,
        })}
      >
        {name}
      </ExternalLink>
    ))}
  </nav>
);
